
import { Box, CircularProgress } from "@mui/material";
import { Done, Error, OfflinePin } from "@mui/icons-material";
import { ICellRendererParams } from "ag-grid-community";
import { ObjectFeaturesEnum } from "../../../common/enums/ObjectFeaturesEnum";
import { CommandStatusEnum } from "../../../services/live-data-service/Models";
import { adjustColorContrast } from "../../../common/utilities/AdjustColorContrast";


export type ITagValueCellRendererProps = {
    offline?: boolean;
    useLKVOffline?: boolean,
    manualEntry?: boolean;
    mobile?: boolean;
    showTimestamp?: boolean;
} & ICellRendererParams;

export default function TagValueRenderer({ data,
    mobile,
    offline,
    useLKVOffline,
    manualEntry,
    showTimestamp
}: ITagValueCellRendererProps) {

    //console.log(`render value tag: ${data.tag.id} ${data.value} and color: ${ data.color}`)
    return (
        <>
            {
                manualEntry ?
                    data.value ?
                        <>
                            <Box sx={{
                                display: "flex",
                                //flexDirection: "column",
                                //flexGrow: 1,
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                            }}>
                                <Box>
                                    {data.value}
                                </Box>
                            </Box>
                            {offline &&
                                <Box sx={{
                                    marginLeft: 'auto',
                                    display: 'flex',
                                    marginTop: 1,
                                    color: 'rgba(0, 0, 0, 0.26)'
                                }}>
                                    <OfflinePin fontSize='small' color='inherit' />
                                    <Box sx={{
                                        marginTop: 'auto',
                                        marginBottom: 'auto'
                                    }}>Offline</Box>
                                </Box>
                            }
                        </> :
                        <Box>
                        </Box> :
                    // not manual entry                
                    <>
                        <Box sx={{
                            display: "flex",
                            color: data.error ? 'red' : data.liveDataStatus === CommandStatusEnum.Success
                                ? '#0000ff'
                                : (data?.tag?.features & ObjectFeaturesEnum.GasComposition) > 0
                                    ? '#006400'
                                    : "inherit",
                            fontWeight: ((data?.tag?.features & ObjectFeaturesEnum.GasComposition) > 0) || data?.inWriteDownMode || data?.color
                                ? 600
                                : "inherit",
                            fontStyle: data?.disabled ? 'italic' : undefined,
                        }}
                            className="ag-cell-value"
                        >
                            <Box
                                sx={{ flex: "1 1 auto" }}
                                className="ag-cell-value"
                            >
                                {offline && data.value === '' ? 'Offline' : data.value}
                            </Box>
                            <Box sx={{ flex: "0 0 auto" }}>
                                {data.liveDataStatus === CommandStatusEnum.InProgress ?
                                    <CircularProgress sx={{
                                        marginLeft: 'auto',
                                        marginTop: 'auto',
                                        marginBottom: 'auto'
                                    }} size={16} /> :
                                    data.liveDataStatus === CommandStatusEnum.Success ?
                                        <Done sx={{
                                            marginLeft: 'auto',
                                            marginTop: 'auto',
                                            marginBottom: 'auto'
                                        }} fontSize='small' color='inherit' /> :
                                        data.liveDataStatus === CommandStatusEnum.Failed ?
                                            <Error sx={{
                                                marginLeft: 'auto',
                                                marginTop: 'auto',
                                                marginBottom: 'auto',
                                                color: data.color ? adjustColorContrast('#C83633', data.color) : '#C83633' 
                                            }} fontSize='small' 
                                            //color={data.color ? 'info' : 'error' }
                                            /> :
                                            null
                                }
                            </Box>
                        </Box>
                        {!offline && mobile && <Box style={{ fontStyle: 'italic', fontSize: '.95em' }}>
                            {showTimestamp ? data.timestamp : data.unit}
                        </Box>}
                        {/* {offline && !useLKVOffline && data.value !== '' &&                               
                    <Box sx={{
                        marginLeft: 'auto', 
                        display: 'flex',
                        marginTop: 1,
                        color: 'rgba(0, 0, 0, 0.26)'
                    }}>
                        <OfflinePin fontSize='small' color='inherit'/>
                        <Box sx={{
                            marginTop: 'auto', 
                            marginBottom: 'auto'
                        }}>Offline</Box>
                    </Box>
                    } */}
                        {
                            offline && data.value !== '' ?
                                useLKVOffline && data.timestamp ?
                                    <Box style={{ fontStyle: 'italic', fontSize: '.95em' }}>
                                        {showTimestamp ? data.timestamp : data.unit}
                                    </Box> :

                                    <Box sx={{
                                        marginLeft: 'auto',
                                        display: 'flex',
                                        marginTop: 1,
                                        color: 'rgba(0, 0, 0, 0.26)'
                                    }}>
                                        <OfflinePin fontSize='small' color='inherit' />
                                        <Box sx={{
                                            marginTop: 'auto',
                                            marginBottom: 'auto'
                                        }}>Offline</Box>
                                    </Box>
                                : null
                        }

                    </>
            }
        </>
    )
}
